import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import DescriptionIcon from '@mui/icons-material/Description';
import ContactMailIcon from '@mui/icons-material/ContactMail';

const report = typeof window !== 'undefined' && window.location ? window.location.search : '';

export const PARENT_MENU_LIST = [
    {
        label: 'Home',
        hasPopUp: false,
        iconPath: HomeIcon,
        hrefLink: '/home',
    },
    {
        label: 'About Us',
        hasPopUp: false,
        iconPath: InfoIcon,
        hrefLink: '/about-us',
    },
    {
        label: 'Scripts',
        hasPopUp: false,
        iconPath: DescriptionIcon,
        hrefLink: '/scripts',
    },
    {
        label: 'Contact Us',
        hasPopUp: false,
        iconPath: ContactMailIcon,
        hrefLink: '/contact',
    },
    
];

export const SCRIPT_MENU_LIST = [
    {
        title: 'Script 1',
        url: `/script/portfolio${report}`,
        parentMenu: 'Profit-Loss Reports',
    },
    {
        title: 'Script 2',
        url: `/script/taxpnl${report}`,
        parentMenu: 'Profit-Loss Reports',
    },
];

